import { useMemo } from 'react';
import { SEAT_CIRCLE_RADIUS } from '../../constants';
import { ceil, floor, round } from '../../utils/utils';
import { createLabelGenerator } from '../../utils/label-generator';
export const useGenericRow = ({ definition, rowContainerInfo, seatAmount = definition.capacity, reverse = false, disablePadding = false, labelIndexOffset = 0, }) => {
    const emptySpace = rowContainerInfo.width - seatAmount * SEAT_CIRCLE_RADIUS * 2;
    let spacing = 0;
    if (emptySpace > 0) {
        spacing = disablePadding ? emptySpace / (seatAmount - 1) : emptySpace / (seatAmount + 1);
    }
    else if (seatAmount > 1) {
        spacing = floor(emptySpace / (seatAmount - 1));
    }
    const getSeatPosition = (index) => {
        const position = sidePadding + SEAT_CIRCLE_RADIUS * 2 * index + spacing * index;
        if (index === 0) {
            return ceil(position);
        }
        else if (index === seatAmount - 1) {
            return floor(position);
        }
        else {
            return round(position);
        }
    };
    const sidePadding = emptySpace > 0 && !disablePadding ? spacing : 0;
    const labelGenerator = createLabelGenerator(definition);
    const labels = useMemo(() => {
        const newLabels = new Array(seatAmount)
            .fill(null)
            .map((_, index) => labelGenerator.getLabelByIndex(index, labelIndexOffset));
        if (reverse) {
            newLabels.reverse();
        }
        return newLabels;
    }, [seatAmount, reverse, labelIndexOffset, labelGenerator]);
    return { labels, getSeatPosition };
};
//# sourceMappingURL=use-generic-row.js.map